module.exports = __webpack_public_path__ + "img/42_37.653fec35.png";